<template>
    <div class="yh-page">
        <el-card>
            <el-collapse v-model="activeNames">
            <el-collapse-item title="基础信息" name="1">
            <el-form ref="form" :model="form" :validate-on-rule-change="false" label-position="right"
                label-width="160px" >
                <div class="container">
                    <div class="left">
                        <el-divider content-position="left">基础信息</el-divider>
                        <el-col :span="15">
                            <el-form-item label="船舶名">
                                <el-input type="textarea" v-model="form.ship_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="所属会员">
                                <el-input type="text" v-model="form.member_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>

                        <el-col :span="18">
                            <el-form-item label="创建人">
                                <el-input type="text" v-model="form.creator_name" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="拒绝原因" v-if="form.status === 3">
                                <el-input type="text" v-model="form.refuse_reason" style="width: 48%;" disabled />
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <!-- 身份证明文件 -->
                            <el-form-item label="申请文件" prop="attachments">
                            <attachment-list 
                                object-type="member.member" :object-id="form.id" :file-list="file_list"
                                :attachment-name="attachment_name"
                                @removed="loadFileList('member.membershipapply', form.id)"></attachment-list>
                            <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
                            </el-form-item>
                        </el-col>

                    </div>
                </div>
            </el-form>
            <!--创建按钮-->
            <div class="btn-box">
                <el-button type="primary" @click="handleSuccess" v-if="opera_type === 'ApplySuccess'">审核通过(船舶)</el-button>
                <el-button type="primary" @click="handleSubmit" v-if="is_member === false && opera_type === 'ApplySuccess'">审核通过(会员)</el-button>
                <el-button type="primary" @click="handleReject" v-if="opera_type === 'ApplySuccess'">审核不通过</el-button>
            </div>
            </el-collapse-item>
            <!-- <el-collapse-item title="相关文书" name="2">
                        <el-col>
                            <file-sign-list :attachments="file_list" object_type="member.membershipapply"></file-sign-list>
                         </el-col>
            </el-collapse-item> -->
            <upload-dialog ref="upload" :object-name="form.ship_name" :file-type-list="file_type_list"
                object-type="member.membershipapply" :object-id="form.id" :append-to-body="true"
                :default-issue-date.sync="default_issue_date" 
                @appended="handleAppended" @uploaded="loadFileList('member.membershipapply', form.id)">
            </upload-dialog>
            <el-dialog :visible.sync="SuggestionVisible" width="50%">
                <el-form ref="refuse_reason" :model="refuse_reason" label-width="120px">
                <el-form-item label="拒绝原因" width="50%">
                    <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addMessage">确 定</el-button>
                </span>
            </el-dialog>
        </el-collapse>
        </el-card>
    </div>
</template>

<script>

import {applyMember,successShipApply,rejectShipApply,getApplyInfo} from '@/api/member'
import UploadDialog from "@/components/UploadDialog"
import { fetchFileList } from "@/utils"
import { fetchFileTypeList, getObjectFileAll } from '@/api/common'
import FileSignList from '@/components/FileSignListDetail'
import AttachmentList from "@/components/AttachmentList"




export default {
    name: "shipApplyDetail",
    components: {
        UploadDialog,
        AttachmentList,
        FileSignList

    },
    computed: {
        attachment_name: function () {
        let name = this.form.ship_name
        return (name + ".zip");
        }
    },
    data() {
        return {
            ship_name:"",
            member:"",
            creator:"",
            apply_time:"",
            default_issue_date: '',
            file_type_list: [],
            activeNames: ["1", "2"],
            file_list: [],
            is_member:true,
            form:{},
            apply_info:{},
            opera_type:"",
            SuggestionVisible:false,
            refuse_reason:"",
            loadingText: '正在加载数据，请稍等...',
        };
    },

    methods: { 
        getData(id){
            getApplyInfo({"id":id}).then(resp => {
                console.log(resp,342374)
                this.form = resp

                })
                .catch(error => {
                    this.loading = false
                    this.$message.error(error)
                })
        },
        handleAppended(fileList) {
            this.file_list = this.file_list.concat(fileList)
            },
        loadFileList(object_type, object_id) {
            getObjectFileAll(object_type, object_id).then(res => {
                this.file_list = res
                this.file_list.forEach(item => {
                    this.$set(item, 'checked', true)
                })
            })
            .catch(error => {
                this.$error_message(error)
            })
        },
        handleUpload() {
            this.$refs.upload.handleOpen()
            },
        handleSubmit() {
            this.$confirm('是否核对会员资料并且通过审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                    }).then(() => {
                applyMember({ id: this.form.member })
                .then(res => {
                    this.$message.success(res)
                })
                .catch(err => {
                    this.$error_message(err)
                })
            }).catch(() => {
                this.$message({
                type: 'info',
                message: '已取消审核'
                });
            });
            },
        addMessage(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                rejectShipApply({'id':this.form.id,'refuse_reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'shipApplyList' })   
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        handleReject() {
            this.SuggestionVisible = true
        },
        handleSuccess() {

          var msg = '是否通过该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            successShipApply(this.form)
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '通过成功!'
                })
                this.$router.push({ name: 'shipApplyList' }) 
              })
              .catch(error => {
                this.$message.error(error)
                this.is_member = false
              })
          })
        },
        loadData() {
            this.getData(this.id)
            console.log(this.form)
            if (this.opear_type  !== 'ApplySuccess'){
                this.loadFileList('member.membershipapply', this.id)
            }
            
            let p0 = fetchFileTypeList({ file_type: "group_ins|sc|bc" })
            Promise.all([p0])
                .then(res => {
 
                this.file_type_list = res[0]

                })
                .catch(error => {
                this.loading = false
                this.$message.error(error)
                })
                },
        
     
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'actList') {
            window.localStorage.removeItem('query')
        }
        next()
    },
    created() {
        this.opera_type = this.$route.query.type
        this.id = this.$route.query.id
        
        // this.getCompanyList()
        // if (this.opear_type  !== 'ApplySuccess'){
        //     this.form = this.$route.query.data
        // }
        // else{
        //     var id =  this.$route.query.data
        //     
        // }
       
        this.loadData()
        // console.log(this.id )
    },
};
</script>

